import {
  CheckCanReferRequest,
  ExistingAdviserReferralMetadataRequest,
} from '../../types/requests/referral-metadata'
import {
  CheckCanReferItem,
  ExistingAdviserReferralMetadataItem,
  NewAdviserReferralMetadataItem,
} from '../../types/responses/referral-metadata'
import apiService from './apiService'

class ReferralMetadataService {
  private endpoint = '/v1/referral-metadata'

  async checkCanRefer(
    request: CheckCanReferRequest,
  ): Promise<CheckCanReferItem> {
    const response = await apiService.post(
      `${this.endpoint}/check-can-refer`,
      request,
    )

    return response.data
  }

  async createExistingAdviserReferralMetadata(
    request: ExistingAdviserReferralMetadataRequest,
  ): Promise<ExistingAdviserReferralMetadataItem> {
    const response = await apiService.post(
      `${this.endpoint}/existing-adviser-referral`,
      request,
    )

    return response.data
  }

  async createNewAdviserReferralMetadata(): Promise<NewAdviserReferralMetadataItem> {
    const response = await apiService.post(
      `${this.endpoint}/new-adviser-referral`,
      {},
    )

    return response.data
  }
}

const referralMetadataService = new ReferralMetadataService()

export default referralMetadataService
